<template>
  <div id="app">
    <profile-overview></profile-overview>
    <player></player>
    <readouts></readouts>
    <div class="chart-wrap">
      <chart-guide></chart-guide>
      <chart></chart>
    </div>
    <leaflet-map></leaflet-map>
  </div>
</template>

<script>
import ProfileOverview from './components/ProfileOverview'
import Player from './components/player/Player'
import ChartGuide from './components/ChartGuide'
import Chart from './components/Chart'
import Readouts from './components/Readouts'
import LeafletMap from './components/LeafletMap'

export default {
  name: 'app',
  components: {
    ProfileOverview,
    Player,
    ChartGuide,
    Chart,
    Readouts,
    LeafletMap
  },
  mounted () {
    this.$store.dispatch('configureConnectionFromParams').then(() => {
      this.$store.dispatch('fetchInfo')
    })
  }
}
</script>

<style>
html, body, #app {
  height: 100%;
  width: 100%;
}

body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50; 
}

.profile-overview {
  width: 100%;
  height: 40px;
  background: #f4f3f1;
}

.player {
  background: black;
}

.readouts {
  background: #f4f3f1;
  height: 40px;
}

.chart-wrap {
  position: relative;
}

.chart {
  height: 60px;
}

@media only screen and (orientation: portrait) {
  .player {
    width: 100%;
    height: calc(50% - 80px);
  }

  .readouts {
    width: 100%;
  }

  .chart-wrap {
    width: 100%;
  }

  .leaflet-map {
    width: 100%;
    height: calc(50% - 60px);
    min-height: 270px; 
  }
}

@media only screen and (orientation: landscape) {
  .player {
    width: 70%;
    height: calc(100% - 40px);
    float: left;
  }

  .readouts {
    width: 30%;
    float: left;
  }

  .chart-wrap {
    width: 30%;
    float: left;
  }

  .leaflet-map {
    width: 30%;
    height: calc(100% - 140px);
    min-height: 270px; 
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?0ae4cc94